import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { getIsQAProxy } from '../utils/proxyUtils';
import { getI18nLangLocale } from '../utils/languageUtils';
export const getFeatures = ({
  highlightedProducts
}) => {
  const i18nLangLocale = getI18nLangLocale();
  return noAuthHttp.get(`${getFullUrl('app-api', getIsQAProxy() ? {
    envOverride: 'qa'
  } : {})}/feature/store/v1/features/by-api-names/translated`, {
    query: {
      productApiNames: highlightedProducts,
      i18nLangLocale
    }
  });
};